import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { CARD_STATUS } from "../../utils/constant";
import CustomCheckBox from "../CustomCheckBox";
import CardTask from "./CardTask";
import useAppState from "context/useAppState";
import Tooltip from "components/common/tooltip/Tooltip";
import allImgPaths from "assets/images";
import dragIcon from "../../assets/images/drag-icon.svg";
import rightIcon from "../../assets/images/right-icon.svg";
import { format } from "date-fns";
import Toggle from "../common/Toggle";
import { useState } from "react";
import { CHAT_SESSION, DEFAULT_FETEBUDDY_INITIATE_MESSAGES, DEFAULT_FETEBUDDY_PROMPT_KEYS, MESSAGE_TYPES } from "constants/llm";
import { useParams } from "react-router-dom";
import { isNewFete } from "utils/fete";
import { getAnswerFromResponse } from "utils/llm";
import { jsonToMarkdown } from "utils/function";
import React from "react";

const Card = (props: any) => {
  const { id } = useParams();
  const {
    card,
    selectedCardId,
    setSelectedCardId,
    onSelectCard,
    saveActiveBlock,
    title,
    columnId
  } = props;

  // console.log({columnId})
  const isTouchDevice = 'ontouchstart' in window || 'ontouchstart' in document.documentElement;
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: card.id,
    data: {
      type: "Card",
      card,
    },
    disabled: isTouchDevice ? true : false,
  });

  const { setState: setEventDataState, unsavedChanges } = useAppState("eventData");
  const { setState: setChatBoxState } = useAppState("chatBox");
  const [activeCard, setactiveCard] = useState(true);
  const [toggleBlock, setToggleBlock] = useState(false);
  
  const {
    fetchCardPrompt,
    fetchChipData,
    setState: setCardWrapperState,
    updateCardSelectedState, 
    columns,
    selectedCardDetail
  } =
    useAppState("cardWrapper");
  const { setState: setChatMessagesState, createSession, getUserChatSessions, getUserChatSessionMessages } = useAppState('chatMessages');
  const { setState: setChatboxState } = useAppState("chatBox");

  const userData = JSON.parse(localStorage.getItem('userData') as string)
  const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

  const getMetadataFilter = (isCard = false) => {
    let metadata_filter: any = {
      teamId: currentTeam?.currentTeamId,
      userId: userData?.id
    }
    if (isNewFete()) {
      return metadata_filter;
    }
    if (id) {
      metadata_filter['eventId'] = id
    }
    if (card && isCard) {
      metadata_filter['cardId'] = card?.id
    }
    return metadata_filter;
  }

  const getMetadataFilterForLLM = (isCard = false) => {
    let metadata_filter: any = {
      teamId: currentTeam?.currentTeamId,
    }
    if (isNewFete()) {
      return metadata_filter;
    }
    if (id) {
      metadata_filter['eventId'] = id
    }
    // if (card && isCard) {
    //   metadata_filter['cardId'] = card?.id
    // }
    return metadata_filter;
  }

  const getChatSessions = async () => {
    const userSessions = await getUserChatSessions({
      page: 0,
      perPage: 10,
      filter: getMetadataFilter(true),
    });
    return userSessions;
  }

  const initChatWithPrompt = () => {
    (async () => {
      const prompt = await fetchCardPrompt(card?.prompt_id);
      if (prompt?.name) {
        setChatMessagesState({ messageHistory: [] })
        const sessionRes = await createSession({
          title: CHAT_SESSION.DRAFT_TITLE,
          metadata: getMetadataFilter(true)
        });
        const userSessions = await getChatSessions();
        setChatboxState({ currentSession: sessionRes, userChatSessions: userSessions?.sessions || [] })
        setChatBoxState({ cardPrompt: prompt })
      }
    })()
  }

  const handleToggleBlock = async (cardId: any) => {
    updateCardSelectedState(cardId, { isSelected: !card.isSelected });
  };

  const style = {
    transition,
    // transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        ref={setNodeRef}
        style={style}
        className="bg-white border border-[#D0D5DD] px-4 py-4 mb-4 shadow-customShadow3"
      />
    );
  }

  const handleClose = (e: any) => {
		if (unsavedChanges) {
			const message = `You’ve unsaved changes in your ${selectedCardDetail?.title || ''} fetebuddy. Do you want to save before proceeding?`
			const confirmLeave = window.confirm(message);
			if (!confirmLeave) {
				e.preventDefault()
				return
			} else {
				setEventDataState({ unsavedChanges: false })
				handleOnSelectCard()
			}
		} else {
			handleOnSelectCard()
		}
	}

  const handleOnSelectCard = async () => {

    // setSelectedCardId(card.id);
    // onSelectCard();
    const chipsData = await fetchChipData(card?._id);
    setCardWrapperState({
      chipsData,
      cardAnimation: true,
      openCardAnimation: true,
      selectedCardDetail: card
    })
    // setEventDataState({ openPlanningAnimation: false, showChatbox: true, showReviewSpace: false, showInsight: false, isInsightCallApi: true });
    
    // callFromEmptyReviewSpace and showReviewSpace true opens review space, with isInsightCallApi for data fetching
    setEventDataState({
      openPlanningAnimation: false,
      showChatbox: true,
      showReviewSpace: true,
      showInsight: false,
      isInsightCallApi: true,
      callFromEmptyReviewSpace: true,
      brainStormText: ''
    })

    props.onSelect();
    setTimeout(() => {
      let getPlanningBoard = document.getElementById("planning-board-scroll-top");
      if (getPlanningBoard) {
        setTimeout(() => {
          updateCardSelectedState(card.id, { isSelected: true });
          setSelectedCardId(card.id);
          onSelectCard();
          setCardWrapperState({
            chipsData,
            cardAnimation: true,
            openCardAnimation: true,
            selectedCardDetail: card
          })
        }, 300);
        getPlanningBoard.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
        initChatWithPrompt()
      }
    }, 300);
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`border border-[#D0D5DD] rounded-lg px-4 py-4 mb-4 shadow-customShadow5 hover:shadow-lg ${title?.replaceAll(" ", "")}-card-wrapper card-selected ${card.isSelected === true ? "" : "collapsed-block"} ${card?.status == 'inactive' ? "decativated-card" : "bg-white"} ${selectedCardId === card.id && "active"
        }`}
    // className={`border border-[#D0D5DD] rounded-lg px-4 py-4 mb-4 shadow-customShadow5 card-wrapper ${!activeCard ? "decativated-card" : "bg-white"} ${
    //   selectedCardId === card.id && "active"
    // }`}
    >
      {/* Upper Heading */}
      <div className="mb-4 card-heading">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="hover:bg-[#f2f4f7] mr-2 w-3.5 h-5 rounded-sm flex items-center justify-center">
             <img className="" src={allImgPaths.dragIcon} alt="" />
            </span>
            <span className="card-checkbox-adjust">
              <CustomCheckBox
                name={card.id}
                checked={card.status === CARD_STATUS.COMPLETED}
                label={card.title}
              />
            </span>

          </div>
          <div className="flex items-center gap-x-2">
            {saveActiveBlock ? <Toggle setactiveCard={setactiveCard} selectedCard={card} /> : <span
              key={card.id}
              // onClick={() => handleOnSelectCard()}
              onClick={handleClose}

              className="cursor-pointer star-color-icon bg-no-repeat w-5 h-5"
            />}
            {/* <span onClick={() => handleToggleBlock(card.id)} className="px-0.5 py-1">
              <img className="w-3 toggle-icon transform rotate-[-180deg]" src={allImgPaths.downArrowIcon1} alt="" />
            </span> */}
          </div>
        </div>

        {/* Date */}
        {card?.due_date !== null || card?.reminder_date !== null ? (
          <div className="flex items-center justify-between pt-3 pl-3 pr-1">
            {card?.due_date !== null && <span className="font-interMedium text-xs text-[#667085] flex gap-x-1 items-center">
              <img src={allImgPaths.calenderCheckCardIcon} alt="" />
              {format(new Date(card.due_date), "dd MMMM yyyy")}
            </span>}

            {card?.reminder_date !== null && (
              <span className="font-interMedium text-xs text-[#667085] flex gap-x-1 items-center">
                <img src={allImgPaths.bellDotCardIcon} alt="" />
                {format(new Date(card.reminder_date), "dd MMMM yyyy")}
              </span>
            )}
          </div>
        ) : (<></>)}
      </div>

      {/* Child Section */}
      <div className="card-children-wrapper">
        {card &&
          card.tasks &&
          card.tasks.length > 0 &&
          card.tasks.map((task: any, taskIndex: number) => (
            <React.Fragment key={taskIndex}>
              <CardTask task={task} />
              {task?.assigned_to && (
                <div className="border-t border-[#EAECF0] pt-2 pb-2 ml-[25px] -mt-1.5">
                  <div className="relative group w-max">
                    <img
                      className="w-6 h-6 rounded-full"
                      src={
                        task?.assigned_to?.profile_image
                          ? task?.assigned_to?.profile_image
                          : allImgPaths.avatar
                      }
                      alt="team-member-icon"
                    />
                    <Tooltip
                      list={[
                        {
                          name: task?.assigned_to?.name,
                          _id: task?.assigned_to?._id,
                          profile_image: "",
                        },
                      ]}
                    />
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
      </div>

    </div>
  );
};
export default Card;
